module.exports = __webpack_public_path__ + "static/img/Railway.c3acf94a.png";